var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('p', [_c('strong', [_vm._v("原文连接："), _c('a', {
    attrs: {
      "href": "https://blog.fengjx.com/openresty/gateway/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://blog.fengjx.com/openresty/gateway/"), _c('OutboundLink')], 1)])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "简介"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#简介"
    }
  }, [_vm._v("#")]), _vm._v(" 简介")]), _vm._v(" "), _c('p', [_vm._v("OpenResty（也称为 ngx_openresty）是一个全功能的 Web 应用服务器。它打包了标准的 Nginx 核心，很多的常用的第三方模块，以及它们的大多数依赖项。")]), _vm._v(" "), _c('p', [_vm._v("通过揉和众多设计良好的 Nginx 模块，OpenResty 有效地把 Nginx 服务器转变为一个强大的 Web 应用服务器，基于它开发人员可以使用 Lua 编程语言对 Nginx 核心以及现有的各种 Nginx C 模块进行脚本编程，构建出可以处理一万以上并发请求的极端高性能的 Web 应用。")]), _vm._v(" "), _c('p', [_vm._v("ngx_openresty 目前有两大应用目标：")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("通用目的的 web 应用服务器。在这个目标下，现有的 web 应用技术都可以算是和 OpenResty 或多或少有些类似，比如 Nodejs, PHP 等等。ngx_openresty 的性能（包括内存使用和 CPU 效率）算是最大的卖点之一。")]), _vm._v(" "), _c('li', [_vm._v("Nginx 的脚本扩展编程，用于构建灵活的 Web 应用网关和 Web 应用防火墙。有些类似的是 NetScaler。其优势在于 Lua 编程带来的巨大灵活性。")])]), _vm._v(" "), _c('p', [_vm._v("引用自："), _c('a', {
    attrs: {
      "href": "https://moonbingbing.gitbooks.io/openresty-best-practices/content/base/intro.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("OpenResty最佳实践"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "入门教程"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#入门教程"
    }
  }, [_vm._v("#")]), _vm._v(" 入门教程")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://moonbingbing.gitbooks.io/openresty-best-practices/content/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("OpenResty 最佳实践"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.iteye.com/blog/jinnianshilongnian-2190344",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("跟我学OpenResty(Nginx+Lua)开发"), _c('OutboundLink')], 1)])]), _vm._v(" "), _c('p', [_vm._v("目前已经有大佬写了很完整的教程，没有必要重复造轮子了，我觉得这两个是最好的。更多openresty相关资料可以看这里"), _c('a', {
    attrs: {
      "href": "https://blog.fengjx.com/awesome/#lua-openresty",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://blog.fengjx.com/awesome/#lua-openresty"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "网关服务开发"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#网关服务开发"
    }
  }, [_vm._v("#")]), _vm._v(" 网关服务开发")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "整体架构"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#整体架构"
    }
  }, [_vm._v("#")]), _vm._v(" 整体架构")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/img/openresty/resty-gateway.jpg",
      "alt": "整体架构"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("服务启动时，将自己的节点信息注册到etcd，包括：服务名称、ip、端口")]), _vm._v(" "), _c('p', [_vm._v("网关服务从etcd监听服务节点信息变更，保存到缓存中，从客户端请求的url中提取服务名称，通过服务名称查找节点信息，将请求转发到后端服务")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("关于etcd的使用，这里不再阐述")])]), _vm._v(" "), _c('p', [_vm._v("url规范")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("对外api前缀："), _c('code', [_vm._v("/open/api/service_name/**")]), _vm._v("，后端服务路由："), _c('code', [_vm._v("/open/api/**")])]), _vm._v(" "), _c('li', [_vm._v("对内api前缀："), _c('code', [_vm._v("/inner/api/service_name/**")]), _vm._v("，后端服务路由："), _c('code', [_vm._v("/**")])])]), _vm._v(" "), _c('p', [_vm._v("例如"), _c('code', [_vm._v("/open/api/user/fav")]), _vm._v("会转发到user服务的"), _c('code', [_vm._v("/open/api/fav")]), _vm._v("接口；"), _c('code', [_vm._v("/inner/api/user/info")]), _vm._v("会转发到user服务的"), _c('code', [_vm._v("/info")]), _vm._v("接口。通过url规范我们就能很轻易的做api鉴权，而不需要将对外api和对内api部署成2个服务（当然也要考虑实际情况，是否符合实际项目要求）。")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "源码解析"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#源码解析"
    }
  }, [_vm._v("#")]), _vm._v(" 源码解析")]), _vm._v(" "), _c('p', [_vm._v("github: "), _c('a', {
    attrs: {
      "href": "https://github.com/tech-microworld/ws-cloud-gateway",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://github.com/tech-microworld/ws-cloud-gateway"), _c('OutboundLink')], 1), _vm._v(" (tag v0.1)")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("init_by_lua_file \"lua/init.lua\"")]), _vm._v(" "), _c('p', [_vm._v("初始化项目配置")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("init_worker_by_lua_file \"lua/init_worker.lua\"")]), _vm._v(" "), _c('p', [_vm._v("初始化服务发现组件，监听服务节点变更信息")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("rewrite_by_lua_file 'lua/rewrite.lua'")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("生成requestId，方便链路跟踪和问题排查")]), _vm._v(" "), _c('li', [_vm._v("解析请求服务名称")]), _vm._v(" "), _c('li', [_vm._v("重写后端请求url，去掉服务名")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("access_by_lua_file 'lua/gateway.lua'")]), _vm._v(" "), _c('p', [_vm._v("通过服务发现组件查询服务节点信息")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("balancer_by_lua_file 'lua/server_rr.lua'")]), _vm._v(" "), _c('p', [_vm._v("通过查询到的节点信息，轮训其中一个节点，将请求转发到后端服务")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("user.conf")]), _vm._v(" "), _c('p', [_vm._v("模拟用户服务")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("auth.conf")]), _vm._v(" "), _c('p', [_vm._v("模拟认证服务")])])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "运行测试"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#运行测试"
    }
  }, [_vm._v("#")]), _vm._v(" 运行测试")]), _vm._v(" "), _c('p', [_vm._v("安装openresty: "), _c('a', {
    attrs: {
      "href": "http://openresty.org/cn/installation.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("http://openresty.org/cn/installation.html"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('p', [_vm._v("启动服务")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("git")]), _vm._v(" clone git@github.com:tech-microworld/ws-cloud-gateway.git\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("cd")]), _vm._v(" ws-cloud-gateway\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# 切换到 tag v0.1")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("git")]), _vm._v(" checkout "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-b")]), _vm._v(" v0.1 v0.1\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# -g 'daemon off;是在前台运行，如果想后台运行可以去掉")]), _vm._v("\nopenresty "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-p")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("`")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("pwd")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token variable"
    }
  }, [_vm._v("`")])]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-c")]), _vm._v(" conf/nginx.conf "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-g")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("'daemon off;'")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br')])]), _c('p', [_vm._v("向etcd注册节点信息，当然实际情况是在服务启动的时候自动注册的，这里为了测试，手动模拟的服务注册过程")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# 注册user服务")]), _vm._v("\netcdctl put /micros/service/user/127.0.0.1:1024 "), _c('span', {
    pre: true,
    attrs: {
      "class": "token number"
    }
  }, [_vm._v("1")]), _vm._v("\netcdctl put /micros/service/user/127.0.0.1:1025 "), _c('span', {
    pre: true,
    attrs: {
      "class": "token number"
    }
  }, [_vm._v("1")]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# 注册auth服务")]), _vm._v("\netcdctl put /micros/service/auth/127.0.0.1:1026 "), _c('span', {
    pre: true,
    attrs: {
      "class": "token number"
    }
  }, [_vm._v("1")]), _vm._v("\netcdctl put /micros/service/auth/127.0.0.1:1027 "), _c('span', {
    pre: true,
    attrs: {
      "class": "token number"
    }
  }, [_vm._v("1")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br')])]), _c('p', [_vm._v("发送http请求")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# 测试auth服务")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("curl")]), _vm._v(" http://localhost:10000/open/api/auth/login\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("curl")]), _vm._v(" http://localhost:10000/inner/api/auth/has-login\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# 测试user服务")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("curl")]), _vm._v(" http://localhost:10000/inner/api/user/fav\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("curl")]), _vm._v(" http://localhost:10000/inner/api/user/info\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br')])]), _c('h3', {
    attrs: {
      "id": "todo"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#todo"
    }
  }, [_vm._v("#")]), _vm._v(" todo")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[x] 服务发现，动态路由")]), _vm._v(" "), _c('li', [_vm._v("[x] 自动生成requestId，方便链路跟踪")]), _vm._v(" "), _c('li', [_vm._v("[ ] 动态ip防火墙")]), _vm._v(" "), _c('li', [_vm._v("[ ] 限流器")]), _vm._v(" "), _c('li', [_vm._v("[ ] 用户登录认证")]), _vm._v(" "), _c('li', [_vm._v("[ ] 接口协议加解密")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };